var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingularitynetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C6.582 2 3 5.545 3 9.919C3 11.412 3.417 12.809 4.143 14M14.5 11V13M17.5 11V13M14.5 3V5M17.5 3V5M13 6.5H11M13 9.5H11M21 6.5H19M21 9.5H19M14 19L13.87 19.647C13.73 20.354 13.659 20.707 13.5 20.987C13.255 21.4186 12.8583 21.7436 12.387 21.899C12.082 22 11.72 22 11 22C10.28 22 9.918 22 9.613 21.9C9.14154 21.7444 8.74482 21.4189 8.5 20.987C8.341 20.707 8.27 20.354 8.13 19.647L8 19M17 5H15C14.057 5 13.586 5 13.293 5.293C13 5.586 13 6.057 13 7V9C13 9.943 13 10.414 13.293 10.707C13.586 11 14.057 11 15 11H17C17.943 11 18.414 11 18.707 10.707C19 10.414 19 9.943 19 9V7C19 6.057 19 5.586 18.707 5.293C18.414 5 17.943 5 17 5ZM6.383 17.098C6.291 16.822 6.245 16.683 6.25 16.571C6.25566 16.4552 6.29475 16.3435 6.36254 16.2494C6.43033 16.1554 6.52393 16.083 6.632 16.041C6.736 16 6.882 16 7.172 16H14.828C15.119 16 15.264 16 15.368 16.04C15.4762 16.0821 15.5699 16.1546 15.6377 16.2489C15.7055 16.3431 15.7445 16.455 15.75 16.571C15.755 16.683 15.709 16.821 15.617 17.098C15.447 17.609 15.362 17.865 15.231 18.072C14.957 18.5046 14.5275 18.8156 14.031 18.941C13.793 19 13.525 19 12.988 19H9.012C8.475 19 8.206 19 7.969 18.94C7.47266 18.8149 7.04319 18.5042 6.769 18.072C6.638 17.865 6.553 17.609 6.383 17.098Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingularitynetLogo);
export default __webpack_public_path__ + "static/media/singularitynet-logo.f5a1eb672cd9a37f458ae2e6f18aa635.svg";
export { ForwardRef as ReactComponent };